import type { Error } from '../types';
import { DNI_CONTROL_LETTERS, NIE_REGEX } from '../utils/regex';
import { validateEsTax } from '../utils/validateEsTax';

export const validateNIE =
  (message?: Error['message']) =>
  (value: string): Error => {
    const replaceNieLetter = (nie: string): string | null => {
      if (!nie || nie.length === 0) return null;
      const nieLetter = nie.charAt(0).toUpperCase();
      if (nieLetter === 'X') return '0' + nie.substring(1);
      if (nieLetter === 'Y') return '1' + nie.substring(1);
      if (nieLetter === 'Z') return '2' + nie.substring(1);
      return null;
    };

    const nieReplaced = replaceNieLetter(value);

    if (!nieReplaced) {
      return {
        valid: false,
        message
      };
    }

    const isNieValid = !NIE_REGEX.test(value) || validateEsTax(nieReplaced, DNI_CONTROL_LETTERS);
    if (!isNieValid) {
      return {
        valid: false,
        message
      };
    }
    return { valid: true };
  };
